/**
 * Generates a user-specific key for localStorage
 * @param {string} baseKey
 * @param {number|string} userId
 * @returns {string}
 */
export const getLSKey = (baseKey, userId) => {
  if (!userId) {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        userId = user?.id;
      } catch (e) {
        console.error('Error parsing user from localStorage', e);
      }
    }
  }
  return userId ? `${baseKey}_${userId}` : baseKey;
};

// Common localStorage keys used in the app
export const LS_KEYS = {
  SELECTED_LABS: 'lsselectedLabs',
  FILTERED_LABS: 'lsfilteredLabs',
  IS_CHECK: 'lsisCheck',
  LIST: 'lslist',
};
